'use client';

import {
  trackCountriesListingCardClick,
  trackCountriesListingRegisterInterestClick,
  trackCountriesListingViewItemClick,
} from '../../analytics';
import {COUNTRIES_EMPTY} from '../../content';
import type {CountryCardView} from '../../model';
import {countryHref} from '../../routing';
import {EntityGridListing} from './EntityGridListing';

export interface CountriesGridCardListingProps {
  locale: string;
  items: CountryCardView[];
}

export function CountriesGridCardListing({locale, items}: CountriesGridCardListingProps) {
  return (
    <EntityGridListing
      titleKey="countries"
      empty={COUNTRIES_EMPTY}
      items={items.map(country => ({
        id: country.uuid,
        title: country.title,
        image: country.image.src,
        href: countryHref(locale, country.uuid),
      }))}
      analytics={{
        onCardClick: trackCountriesListingCardClick,
        onViewItemClick: trackCountriesListingViewItemClick,
        onRegisterInterestClick: trackCountriesListingRegisterInterestClick,
      }}
    />
  );
}

CountriesGridCardListing.displayName = 'CountriesGridCardListing';
